
<div class="progressbardiv">
  <mat-progress-bar *ngIf="progressPercent!=null" [value]="progressPercent" mode="determinate"></mat-progress-bar>
</div>

<div class="row" [ngClass]="{
  'isPaused': !isRunning,
  'isError': errortext
}">

  <div class="cancelbutton">
    <button mat-button (click)="onClear()" title="Abbruch" ><i class="material-icons">clear</i></button>
  </div>
  <div class="filename">
    {{file.name}}
  </div>
  <div class="filesize" *ngIf="!errortext">
    {{file.size | fileSize}}
  </div>
  <div class="uploadState" *ngIf="!errortext">
    <span *ngIf="!isRunning">wartet...</span>
    <span *ngIf="isRunning">{{progressPercent}}%</span>
  </div>
  <div class="errorDiv" *ngIf="errortext">
    <span class="errorText">FEHLER: {{errortext}}</span>
  </div>
</div>
